import resource from "../../Util/resources";

import Layout from './../../Components/Layout/DefaultLayout.vue';
import Index from './Components/Index.vue';

const routes = [{
    path: '/PushNotifications/',
    alias: '/PushNotifications/Index',
    component: Layout,
    meta: {
        title: resource('PushNotifications_Index_Title'), //PushNotifications_Index_Title
        breadcrumb: resource('Breadcrumb_PushNotifications') //Breadcrumb_Newsroom
    },
    children: [{
        name: 'push-notifications-index',
        path: '',
        component: Index
    }]
}];

export {
    routes
}